import { createUseStyles } from 'react-jss'
import { BLACK, GRAY, GUN_GRAY } from '@omnilert/components'

export default createUseStyles({
  listItem: ({ disabled, index }) => ({
    alignItems: 'center',
    borderBottom: `1px solid ${GRAY}`,
    borderTop: index === 0 ? `1px solid ${GRAY}` : 'none',
    opacity: disabled && '.4',
    pointerEvents: disabled && 'none',
    display: 'flex',
    flexDirection: 'row',
    fontFamily: 'BentonSansMedium',
    justifyContent: 'space-between',
    padding: '20px 0'
  }),
  responses: {
    color: GUN_GRAY,
    fontSize: '12px',
    marginTop: '10px'
  },
  rightComponentContainer: {
    alignItems: 'center',
    display: 'flex'
  },
  text: {
    marginRight: '36px',
    width: '100%'
  },
  title: {
    color: BLACK,
    fontFamily: 'BentonSansBold',
    fontSize: '16px',
    marginBottom: '5px'
  },
  wrapper: {
    '&:hover': {
      cursor: ({ disabled }) => disabled ? 'not-allowed' : 'pointer'
    }
  }
})

